import { AxiosResponse } from 'axios';
import { ApiPaths } from 'services/api/apiPaths';
import RedisApiAxiosInstance from '../../services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { GetSystemLogsPayload, GetSystemLogsResponse } from './systemLogs.types';

export const getSystemLogs = ({
  textSearch,
  pageSize,
  page,
  sortAscending,
  sortedColumn
}: GetSystemLogsPayload): Promise<AxiosResponse<GetSystemLogsResponse>> =>
  RedisApiAxiosInstance.get(ApiPaths.SYSTEM_LOGS, {
    params: {
      filter_by: textSearch || '',
      page,
      per_page: pageSize,
      sortAscending,
      sortedColumn
    }
  });
